/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Grid, Button } from '@mui/material';
import { fonts, themes } from '../../themes/themes';

interface handleClick {
  onClickSave: any;
  title?: string;
  textTransform?: any;
  children?: ReactNode;
}

const disabledStyle = {
  minWidth: '118px',
  maxWidth: 'fitContent',
  height: 'auto',
  maxHeight: '42px',
  color: 'White',
  boxShadow: '0px 2px 2px #00000061',
  backgroundColor: themes.greyDefault,
  borderRadius: '4px',
  fontFamily: fonts.fontFamily,
  cursor: 'not-allowed',
};

const CustomSaveButton: React.FC<handleClick> = ({
  onClickSave,
  title,
  textTransform = 'none',
  children,
}) => {
  return (
    <Grid item>
      <Button
        style={
          children
            ? disabledStyle
            : {
                minWidth: '118px',
                maxWidth: 'fitContent',
                height: 'auto',
                maxHeight: '42px',
                color: '#2196F3',
                border: '1px solid #2196F3',
                backgroundColor: '#E8F4FE',
                borderRadius: '4px',
                fontFamily: fonts.fontFamily,
                textTransform: textTransform,
              }
        }
        onClick={onClickSave}
        disabled={children ? true : false}
      >
        {title}
        {children}
      </Button>
    </Grid>
  );
};

export default CustomSaveButton;
